import { defineMessages } from 'react-intl';

const _default_1: {
	readonly deleteIconLabel: {
		readonly id: 'ai-mate.studio-update-agent-draft.agent-diff.delete-field-renderer.delete-icon-label';
		readonly defaultMessage: 'Delete field value';
		readonly description: 'Label for the delete icon in scenario content';
	};
	readonly defaultDeleteDescription: {
		readonly id: 'ai-mate.studio-update-agent-draft.agent-diff.delete-field-renderer.delete-description';
		readonly defaultMessage: 'Delete {fieldName}.';
		readonly description: 'Default description text for a deleted field value in agent content';
	};
} = defineMessages({
	deleteIconLabel: {
		id: 'ai-mate.studio-update-agent-draft.agent-diff.delete-field-renderer.delete-icon-label',
		defaultMessage: 'Delete field value',
		description: 'Label for the delete icon in scenario content',
	},
	defaultDeleteDescription: {
		id: 'ai-mate.studio-update-agent-draft.agent-diff.delete-field-renderer.delete-description',
		defaultMessage: 'Delete {fieldName}.',
		description: 'Default description text for a deleted field value in agent content',
	},
} as const);
export default _default_1;
